
import { defineComponent, ref, SetupContext, getCurrentInstance, onMounted, PropType, computed } from 'vue';
import { getQuery } from '~/common/utils';
import { AIFeedPageEnum } from '~/store/modules/ai-feed';
import { logForTopBarInboxBtnClick, logForTopBarUGCEntranceBtnClick } from '../../scripts/logger';
import { AIFeed } from '~/api/ai-feed';
import useAppEnvironment from '../../hooks/useAppEnvironment';
import { PwaBridge } from '~/common/bridge';
import AiInboxIcon from '@/pages/aichat/images/ai_inbox.png';
import AiCloseIcon from '@/pages/aichat/images/ai_close.png';
import AiFeedIcon from '@/pages/aichat/images/ai_feedback.png';
import NavBackWhiteIcon from '@/pages/aichat/images/kibt_common_nav_back_white.png';
import AiMenuIcon from '@/pages/aichat/images/ai_menu.png';
import AiUGCEntranceIcon from '@/pages/aichat/images/ai_ugc_entrance.png';

const HistoryIconCdnUrl = AiInboxIcon;
const FeedbackIconCdnUrl = AiFeedIcon;
const NaviBackIconCdnUrl = AiCloseIcon;
const BackWhiteIconCdnUrl = NavBackWhiteIcon;

const AITopBar = defineComponent({
    components: {},
    props: {
        feedPage: {
            type: String as PropType<AIFeedPageEnum> | undefined,
            default: AIFeedPageEnum.AIForyou,
        },
        bot: {
            type: Object as PropType<AIFeed> | undefined,
            default: undefined,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    emits: ['onClickSearch', 'onClickMore', 'onClickHistory', 'onClickMute'],
    setup(props, ctx: SetupContext<Array<'onClickSearch' | 'onClickHistory' | 'onClickMute'>>) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };

        const historyBtnSrc = computed(() => {
            return HistoryIconCdnUrl;
        });

        const feedbackBtnSrc = computed(() => {
            return FeedbackIconCdnUrl;
        });

        const chatRoomMode = computed(() => {
            return props.feedPage === AIFeedPageEnum.AIChatRoom;
        });

        const foryouMode = computed(() => {
            return props.feedPage === AIFeedPageEnum.AIForyou;
        });

        const shouldShowRightContainer = ref(false);
        const shouldShowLeftContainer = ref(false);
        const feedbackBotId = computed(() => '738470468051295297');

        const { isKwaiApp, statusHT, isKwaiAppCSR, isAppEnvironment, isBomdiaApp } = useAppEnvironment();

        const handleClickHistory = () => {
            // eslint-disable-next-line vue/require-explicit-emits
            proxy.$nextTick(() => {
                const query = getQuery();
                proxy.$router.push({
                    path: '/aichat/inbox',
                    query: { ...query },
                });
            });
            logForTopBarInboxBtnClick(props.bot?.bot_id_str, `${props.index + 1}`);
        };

        const isLogin = computed(() => proxy?.$store?.state?.isLogin);

        const handleClickUGCEntrance = () => {
            logForTopBarUGCEntranceBtnClick(props.bot?.bot_id_str, `${props.index + 1}`);
            // eslint-disable-next-line vue/require-explicit-emits
            if (isLogin.value) {
                proxy.$nextTick(() => {
                    proxy?.$store?.commit?.('aiCreateMoudle/setPushCreatePage', true);
                    const query = getQuery();
                    proxy.$router.push({
                        path: '/aichat/create',
                        query: { ...query },
                    });
                });
            } else {
                proxy?.$store?.commit?.('popupModule/triggerLoginPopup');
            }
        };

        const handleNaviBack = () => {
            if (window?.history?.length > 0) {
                window?.history.back();
            } else {
                const query = getQuery();
                proxy.$router.push({ path: '/foryou', query: { ...query } });
            }
        };

        const handleLeftClick = async () => {
            try {
                const res = await PwaBridge.closeWebview();
                // eslint-disable-next-line no-console
                console.log('res', res);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        };

        const shouldShowBackIcon = computed(() => chatRoomMode.value || isKwaiAppCSR.value);
        const backIconSrc = computed(() => (chatRoomMode.value ? NaviBackIconCdnUrl : isKwaiApp ? BackWhiteIconCdnUrl : AiMenuIcon));
        const handleLeftIconClick = () => {
            if (chatRoomMode.value) {
                handleNaviBack();
            } else if (isKwaiApp) {
                handleLeftClick();
            } else {
                proxy?.$store?.commit?.('popupModule/setShowSideBar', true);
            }
        };

        const handleClickFeedback = async () => {
            const query = getQuery();
            proxy.$router.push({
                path: `/aichat/room/${feedbackBotId.value}`,
                query: { ...query },
            });
        };

        onMounted(() => {
            shouldShowRightContainer.value = !isBomdiaApp;
            shouldShowLeftContainer.value = !isBomdiaApp && (foryouMode.value || chatRoomMode.value);
        });

        return {
            historyBtnSrc,
            chatRoomMode,
            foryouMode,
            NaviBackIconCdnUrl,
            BackWhiteIconCdnUrl,
            AIFeedPageEnum,
            isKwaiApp,
            isKwaiAppCSR,
            isAppEnvironment,
            statusHT,
            shouldShowBackIcon,
            backIconSrc,
            shouldShowRightContainer,
            shouldShowLeftContainer,
            AiUGCEntranceIcon,
            feedbackBtnSrc,

            handleClickHistory,
            handleClickUGCEntrance,
            handleNaviBack,
            handleLeftClick,
            handleLeftIconClick,
            handleClickFeedback,
        };
    },
});

export default AITopBar;
